export const usdtContractAddress = "0x55d398326f99059fF775485246999027B3197955";
export const nftPresaleContractAddress = "0xE9bD31Cff8468a2b042E8EC7e4Ad2E6f45639A7f";